import { motion } from "framer-motion";
import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";
import Header from "../components/Header";
import BottomTabBar from "../components/BottomTabBar";

export default function BillingCancel() {
  const nav = useNavigate();
  return (
    <div className="warm-bg min-h-screen">
      <Header />
      <main className="max-w-xl mx-auto px-6 pt-16 pb-20 relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          className="card-glow rounded-3xl p-8 text-center"
          data-testid="billing-cancel-card"
        >
          <h1 className="font-display text-2xl font-bold text-white mb-2">No worries — you're still on Free 💫</h1>
          <p className="text-sm text-[#C9C7D9] mb-6">You can unlock Premium anytime from the pricing page or tapping a locked pack.</p>
          <div className="flex gap-3 justify-center">
            <button
              onClick={() => nav("/")}
              className="bg-white/5 border border-white/10 text-white hover:bg-white/10 rounded-full px-5 py-3 font-bold inline-flex items-center gap-2 transition"
              data-testid="billing-cancel-home"
            >
              <ArrowLeft className="w-4 h-4" /> Back
            </button>
            <button
              onClick={() => nav("/pricing")}
              className="btn-gradient rounded-full px-5 py-3 font-bold active:scale-95"
              data-testid="billing-cancel-pricing"
            >
              See plans
            </button>
          </div>
        </motion.div>
      </main>
      <BottomTabBar />
    </div>
  );
}
